import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config";

const API =
`${config.API_BASE_URL}/api/gallery`;

export default function AdminGallery() {

  const [photos,setPhotos] = useState([]);
  const [file,setFile] = useState(null);

  const [form,setForm] = useState({
    category:"",
    title:""
  });

  const loadPhotos = async () => {

    const res =
      await axios.get(API);

    setPhotos(
      res.data.data || []
    );
  };

  useEffect(() => {
    loadPhotos();
  }, []);

  const uploadPhoto = async () => {

    if(!file) {
      alert("Select image");
      return;
    }

    const fd = new FormData();

    fd.append("image",file);
    fd.append("category",form.category);
    fd.append("title",form.title);

    await axios.post(API,fd);

    alert("Uploaded");

    setForm({
      category:"",
      title:""
    });

    setFile(null);

    loadPhotos();
  };

  const deletePhoto = async(id) => {

    if(!window.confirm("Delete photo?"))
      return;

    await axios.delete(
      `${API}/${id}`
    );

    loadPhotos();
  };

  return (
    <div className="admin-page">

      <h2>Gallery Management</h2>

      <div className="admin-form">

        <input type="text"
          placeholder="Category"
          value={form.category}
          onChange={(e)=>
            setForm({
              ...form,
              category:e.target.value
            })
          }
        />

        <input type="text"
          placeholder="Title"
          value={form.title}
          onChange={(e)=>
            setForm({
              ...form,
              title:e.target.value
            })
          }
        />

        <input
          type="file"
          onChange={(e)=>
            setFile(
              e.target.files[0]
            )
          }
        />

        <button onClick={uploadPhoto}>
          Upload Photo
        </button>

      </div>

      <div className="gallery-grid">

        {photos.map(photo => (

          <div
            key={photo.id}
            className="gallery-card"
          >

            <img
              src={`${config.API_BASE_URL}/uploads/${photo.image}`}
              alt=""
            />

            <h4>{photo.title}</h4>

            <p>{photo.category}</p>

            <button
              onClick={() =>
                deletePhoto(photo.id)
              }
            >
              Delete
            </button>

          </div>

        ))}

      </div>

    </div>
  );
}